// src/components/SEO.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = 'Dismhecol - Distribuidora de Medicamentos y Hospitalarios',
    description = 'Distribuidora de medicamentos genéricos, éticos, comerciales, dispositivos médicos e insumos hospitalarios en Pasto, Nariño. Más de 13 años de experiencia.',
    keywords = 'medicamentos, dispositivos médicos, insumos hospitalarios, farmacia, Pasto, Nariño, Colombia, medicamentos genéricos, equipos médicos, medicamentos alto costo, vacunas',
    ogType = 'website',
    ogImage = '/logo192.png',
    canonical,
    noindex = false
}) => {
    const siteUrl = 'https://dismhecol.com'; // Update with actual domain
    const fullUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
    const fullImageUrl = `${siteUrl}${ogImage}`;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Canonical URL */}
            {canonical && <link rel="canonical" href={fullUrl} />}

            {/* Robots */}
            {noindex && <meta name="robots" content="noindex,nofollow" />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={ogType} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImageUrl} />
            <meta property="og:site_name" content="Dismhecol" />
            <meta property="og:locale" content="es_CO" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullUrl} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={fullImageUrl} />

            {/* Additional Meta Tags */}
            <meta name="author" content="Dismhecol S.A.S" />
            <meta name="geo.region" content="CO-NAR" />
            <meta name="geo.placename" content="Pasto" />
            <meta name="geo.position" content="1.2136;-77.2811" />
            <meta name="ICBM" content="1.2136, -77.2811" />
        </Helmet>
    );
};

export default SEO;
